import { useMemo } from 'react';
import type { VoidFunctionComponent } from 'react';

import { DetailsPanelList } from '../../../generic/DetailsPanel';
import type { SnippetConversion } from '../convert/utils';

type Props = {
  snippetConversion: SnippetConversion;
};

/**
 * The Package Summary for snippet conversion
 */
const SnippetConversionSummary: VoidFunctionComponent<Props> = ({ snippetConversion }) => {
  const rows = useMemo(() => {
    return [
      {
        label: 'Name',
        content: (
          <span>
            {snippetConversion.packageName}
          </span>
        ),
      },
      {
        label: 'Version',
        content: (
          <span>
            {snippetConversion.revision}
          </span>
        ),
      },
      {
        label: 'Locator',
        content: (
          <span>
            {snippetConversion.locator}
          </span>
        ),
      },
    ];
  }, [snippetConversion]);

  return (
    <DetailsPanelList rows={rows} />
  );
};

export default SnippetConversionSummary;
